import { Box, LinearProgress, Stack, Typography } from '@mui/material';
import { Referral } from '../types';
import { getReferralProgress } from '../utils';

type ReferralProgressIndicatorProps = {
  referral: Referral;
  compact?: boolean;
};

export default function ReferralProgressIndicator({
  referral,
  compact = false,
}: ReferralProgressIndicatorProps) {
  const progress = getReferralProgress(referral);
  const value = progress.required
    ? Math.min((progress.completed / progress.required) * 100, 100)
    : 0;

  return (
    <Stack spacing={0.75} sx={{ minWidth: compact ? 130 : 180 }}>
      <Stack direction="row" justifyContent="space-between" spacing={2}>
        <Typography variant="body2" sx={{ fontWeight: 700 }}>
          {progress.completed} / {progress.required}
        </Typography>
        {!compact && (
          <Typography variant="caption" color="text.secondary">
            paid sessions
          </Typography>
        )}
      </Stack>
      <LinearProgress
        variant="determinate"
        value={value}
        sx={{
          height: compact ? 6 : 8,
          borderRadius: 1,
          bgcolor: 'grey.200',
        }}
      />
      {!compact && (
        <Typography variant="caption" color="text.secondary">
          {progress.remaining} remaining
        </Typography>
      )}
    </Stack>
  );
}
